import React, { useContext } from 'react';
import styled from 'styled-components';
import { Popover } from 'react-tiny-popover';

import ThemeContext from '../../theme/ThemeContext';
import ThemeIcons from '../../theme/Icons';

import Icon from './Icon';
import Button from './Button';

const StyledPopover = styled.div`
  max-width: 280px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.backgroundColor};
  border-radius: ${(props) => props.theme.borderRadius}px;
  border: 1px solid ${(props) => props.theme.borderColor};
  box-shadow: 0px 1px 6px 1px rgba(20, 20, 23, 0.25);
  padding: 12px;
  font-family: ${(props) => props.theme.fontFamily};
`;

const StyledTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
`;

const StyledTitleText = styled.div`
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  margin-left: 8px;
  color: ${(props) => props.theme.fontColorPrimary};
`;

const StyledDesc = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  margin-bottom: 8px;
  color: ${(props) => props.theme.fontColorPrimary};
`;

const StyledActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

const StyledAction = styled.div`
  margin-left: 8px;
`;

const Popconfirm = ({
  isOpen = false,
  containerStyles = {},
  reposition = false,
  positions = ['top', 'bottom', 'right', 'left'], //preferred positions by priority
  padding = 8,
  title = 'Are you sure?',
  description = '',
  onConfirm,
  onCancel,
  confirmText = 'Yes',
  cancelText = 'No',
  onClickOutside,
  children
}) => {

  const theme = useContext(ThemeContext);

  return (
    <Popover
      reposition={reposition}
      isOpen={isOpen}
      positions={positions}
      padding={padding}
      containerStyle={{ zIndex: 10000 }}
      content={(
        <StyledPopover theme={theme} style={containerStyles}>
          <StyledTitle>
            <Icon size="sm" icon={ThemeIcons.misc.info} color={theme.warningColor} />
            <StyledTitleText theme={theme}>{title}</StyledTitleText>
          </StyledTitle>
          {!description ? null : (<StyledDesc theme={theme}>{description}</StyledDesc>)}
          <StyledActions>
            <StyledAction>
              <Button
                size="sm"
                text={cancelText}
                onClick={onCancel}
              />
            </StyledAction>
            <StyledAction>
              <Button
                size="sm"
                text={confirmText}
                onClick={onConfirm}
              />
            </StyledAction>
          </StyledActions>
        </StyledPopover>
      )}
      onClickOutside={onClickOutside}
    >
      {children}
    </Popover>
  );

};

export default Popconfirm;
